import angular from 'angular';
import uiRouter from 'angular-ui-router';
import adpMenuTogglerComponent from './adpMenuToggler.component';

let adpMenuTogglerModule = angular.module('adpMenuToggler', [
  uiRouter
])

.component('adpMenuToggler', adpMenuTogglerComponent)

.name;

export default adpMenuTogglerModule;



// WEBPACK FOOTER //
// ./src/app/components/adpMenuToggler/adpMenuToggler.js